function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#67BBB0",
  d: "M0,80C0,35.817,35.817,0,80,0s80,35.817,80,80c0,44.184-35.817,80-80,80S0,124.184,0,80"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M107.966,42.25H52.035c-1.519,0-2.75,1.232-2.75,2.75v70c0,1.519,1.231,2.75,2.75,2.75h55.931 c1.518,0,2.75-1.231,2.75-2.75V45C110.716,43.482,109.483,42.25,107.966,42.25 M105.216,112.25H54.785v-64.5h50.431V112.25z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M65.069,69.268h1.809c1.518,0,2.75-1.231,2.75-2.75s-1.232-2.75-2.75-2.75h-1.809 c-1.519,0-2.75,1.231-2.75,2.75S63.55,69.268,65.069,69.268"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M65.069,82.75h1.809c1.518,0,2.75-1.23,2.75-2.75c0-1.519-1.232-2.75-2.75-2.75h-1.809 c-1.519,0-2.75,1.231-2.75,2.75C62.319,81.52,63.55,82.75,65.069,82.75"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M65.069,96.232h1.809c1.518,0,2.75-1.231,2.75-2.75c0-1.52-1.232-2.75-2.75-2.75h-1.809 c-1.519,0-2.75,1.23-2.75,2.75C62.319,95.001,63.55,96.232,65.069,96.232"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M76.169,69.268h18.764c1.518,0,2.75-1.231,2.75-2.75s-1.232-2.75-2.75-2.75H76.169 c-1.519,0-2.75,1.231-2.75,2.75S74.65,69.268,76.169,69.268"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M76.169,82.75h18.764c1.518,0,2.75-1.23,2.75-2.75c0-1.519-1.232-2.75-2.75-2.75H76.169 c-1.519,0-2.75,1.231-2.75,2.75C73.419,81.52,74.65,82.75,76.169,82.75"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M76.169,96.232h18.764c1.518,0,2.75-1.231,2.75-2.75c0-1.52-1.232-2.75-2.75-2.75H76.169 c-1.519,0-2.75,1.23-2.75,2.75C73.419,95.001,74.65,96.232,76.169,96.232"
});

var SvgCircolariAccent = function SvgCircolariAccent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "-0.349 -0.786 161 161",
    enableBackground: "new -0.349 -0.786 161 161",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCircolariAccent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circolari_accent.a5cf8717.svg";
export { ForwardRef as ReactComponent };